import { Link } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { ArrowUpRight } from 'lucide-react';
import { Suspense } from 'react';
import { diamondGlows, DiamondGrid, Squiggle } from '../primitives';
import { Stats } from './stats';

export function Hero() {
	const { t } = useLingui();
	return (
		<section className="relative overflow-hidden">
			{/* Figma's glows, y 95px less than its page coordinates (the header); their own 0.4 alpha is the intensity. */}
			<DiamondGrid
				className="-z-10"
				opacity={1}
				masks={[
					diamondGlows(
						{ x: '-44.5px', y: '269.5px' },
						{ x: 'calc(100% - 15.5px)', y: '288.5px' },
						{ x: '50%', y: '496.5px' },
					),
				]}
			/>
			<div className="mx-auto max-w-[1440px] px-6 xl:px-10">
				{/* The export's exact type scale: don't round to Tailwind steps (`tracking-tight` is -0.025em, not -0.02em). */}
				<div className="mx-auto flex max-w-[1062px] flex-col items-center gap-6 pt-10 pb-14 text-center md:pt-[60px]">
					{/* Nested as Figma does: the pair 8px apart, 24px to the CTAs. */}
					<div className="flex flex-col items-center gap-2">
						<h1 className="text-4xl leading-[1.143] font-medium tracking-[-0.02em] text-balance md:text-[3.5rem]">
							{t`We transform the way we shop to build a`} <Squiggle>{t`better world`}</Squiggle>.
						</h1>
						<p className="text-ink max-w-[628px] text-base leading-[1.5]">
							{t`We connect companies, consumers and NGOs through transparent fundraising technology to finance social projects all over the world.`}
						</p>
					</div>
					{/* A solid badge: a translucent one disappears against the ink. */}
					<div className="flex flex-wrap justify-center gap-3">
						{/* Solutions, not Contact: that page ends on the form anyway, after saying what we do. */}
						<Link
							to="/www/solutions"
							className="bg-ink flex items-center gap-2 rounded-full py-2.5 pr-2.5 pl-4 text-sm font-medium text-white transition-opacity hover:opacity-90"
						>
							{t`I'm a company`}
							<span className="text-ink grid size-6 place-items-center rounded-full bg-white">
								<ArrowUpRight className="size-3.5" />
							</span>
						</Link>
						<Link
							to="/www/partner-ngos"
							className="bg-ink flex items-center gap-2 rounded-full py-2.5 pr-2.5 pl-4 text-sm font-medium text-white transition-opacity hover:opacity-90"
						>
							{t`I'm an NGO`}
							<span className="text-ink grid size-6 place-items-center rounded-full bg-white">
								<ArrowUpRight className="size-3.5" />
							</span>
						</Link>
					</div>
				</div>
			</div>
			{/* The bento's own height: two `h-44` rows, a gap and `pb-16`; from `md`, its `h-96` + `h-72` column and `pb-24`. */}
			<Suspense fallback={<div className="h-108 md:h-196" />}>
				<Stats />
			</Suspense>
		</section>
	);
}
